import { Info } from "../alert";
import { PylonLink } from "../pylon";

export const FeatureFlag = ({
  featureName = "This feature",
  plural = false,
  contactMessage = "",
}) => (
  <Info>
    {featureName} must be enabled by Hightouch.{" "}
    <PylonLink
      pylonText={
        contactMessage ||
        `Hi, I'd like to enable ${featureName.toLowerCase()} in my workspace.`
      }
    >
      Contact us
    </PylonLink>{" "}
    to {plural ? "turn them on" : "turn it on"}.
  </Info>
);
